import React, { useState/* , useEffect */ } from 'react'
import styled from 'styled-components'

const MainBox = styled.div`
  height: 240px;
  width: 240px;
  background: gray;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  transition: 1s;
`

const MoveBox = props => {
  const [x, xSet] = useState(0)
  const [y, ySet] = useState(0)
  const [reverse, reverseSet] = useState(true)

  const onClick = _=> {
    xSet(Math.floor(Math.random() * 400))
    ySet(Math.floor(Math.random() * 400))
    reverseSet(!reverse)
  }

  return (
    <MainBox
      style={{
        ...props.bgColor ? { background: props.bgColor } : {},
        transform: `translate(${ x }px, ${ y }px) rotate(${ reverse ? 360 : 0 }deg)`
      }}
      onClick={onClick}
    >
      {props.text ? props.text : ''}
    </MainBox>
  )
}

export default MoveBox
